export class CustomerColorHelper {
    static getColorForCustomer(customerId: number): string {
        const hue = (customerId * 137.508) % 360;
        return `hsl(${hue}, 65%, 55%)`;
    }
}
